import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postMobile3 } from "./LandingPageCRUD";
import { landingPageSlice } from "./LandingPageSlice";

const { actions } = landingPageSlice;

export const getLandingPageList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMobile3(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.landingPageListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: getLandingPageList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};
